import React from "react";
import { FormattedMessage } from "react-intl";

class CompanyMotto extends React.Component {
    render() {
        return (
            <div className="motto-wrapper">
                <div className="company-motto">
                </div>
            </div>
        );
    }

}

export default CompanyMotto;